const SP = {};

const setVars = () => {
  // DOM Elements
  SP.sportspage       = cube.$id('sportspage');
  SP.header           = cube.$id('header');
  SP.topBar           = cube.$id('top-message-bar');
  SP.navBar           = cube.$('.sportspage__navigation');
  SP.navBarItems      = cube.$$('.sportspage__nav-item[data-index]');
  SP.internalNavItems = cube.$$('.sportspage__nav-item[data-reach]');
  SP.floorsContainer  = cube.$class('sportspage__floors');
  SP.floors           = cube.$$('.sportspage__floor');
  SP.floorsAnchors    = cube.$$('.sportspage__floor-anchor');

  // Utils variables
  SP.scrollDuration        = 750;
  SP.currentIndex          = 0;
  SP.authorizeBlankNavItem = false;
  SP.activeClass           = 'sportspage__nav-item--active';

  // Array of each floor offset Top (use for active nav items)
  SP.floorsHeihts          = [];
  SP.floors.forEach(floor => SP.floorsHeihts.push(floor.offsetTop));
};



const getHeaderHeight = () => {
  let height = 0;
  height += SP.header ? SP.header.clientHeight : 0;
  height += SP.topBar ? SP.topBar.clientHeight : 0;
  return height;
};



const fixNavBar = () => {
  const offset = SP.sportspage.clientHeight - window.innerHeight + getHeaderHeight();
  SP.navBar.classList.toggle('sportspage__navigation--bottom-fitted', window.scrollY >= offset);
};



const highlightNavBarItems = () => {
  const closestHeight = SP.floorsHeihts.reduce((previous, current) => {
    return Math.abs(current - window.scrollY) < Math.abs(previous - window.scrollY) ? current : previous;
  });

  SP.floors.forEach(floor => {
    const anchor = floor.previousElementSibling;

    if ([...SP.floorsAnchors].indexOf(anchor) >= 0) {
      const currentItem = [...SP.navBarItems].find(item => item.matches(`[data-index="${anchor.dataset.index}"]`));

      SP.navBarItems.forEach(item => {
        if (SP.authorizeBlankNavItem) {
          item.classList.remove(SP.activeClass);
        }

        if (currentItem && floor.offsetTop === closestHeight) {
          item.classList.remove(SP.activeClass);
          currentItem.classList.add(SP.activeClass);
        }
      });
    }
  });
};



const goToFloor = index => {
  const anchor = cube.$(`.sportspage__floor-anchor[data-index="${index}"]`);

  if (anchor.nextElementSibling.matches('.sportspage__floor')) {
    cube.ui.smoothScroll(anchor, {
      duration: SP.scrollDuration,
      offset: -1 * getHeaderHeight(),
    });

    SP.currentIndex = index;
  }
};



const reachFloor = direction => {
  const currentIndex = parseInt(SP.currentIndex, 10);
  const prevIndex    = Math.max(currentIndex - 1, 0);
  const nextIndex    = Math.min(currentIndex + 1, SP.floorsAnchors.length);
  const isValid      = anchor => anchor.nextElementSibling && anchor.nextElementSibling.matches('.sportspage__floor');

  if (direction === 'prev' && SP.currentIndex > 0) {
    const prevAnchor = cube.$(`.sportspage__floor-anchor[data-index="${prevIndex}"]`);

    if (prevAnchor) {
      if (isValid(prevAnchor)) goToFloor(prevIndex);
      else {
        SP.currentIndex = prevIndex;
        reachFloor('prev');
      }
    }
  }


  if (direction === 'next' && SP.currentIndex < SP.floors.length) {
    const nextAnchor = cube.$(`.sportspage__floor-anchor[data-index="${nextIndex}"]`);

    if (nextAnchor) {
      if (isValid(nextAnchor)) goToFloor(nextIndex);
      else {
        SP.currentIndex = nextIndex;
        reachFloor('next');
      }
    }
  }
};



const navBarNavigation = event => {
  event.preventDefault();
  goToFloor(event.target.dataset.index);
};



const keyboardNavigation = event => {
  if (event.which === 38) {
    event.preventDefault();
    reachFloor('prev');
  }

  if (event.which === 40) {
    event.preventDefault();
    reachFloor('next');
  }
};



const internalNavigation = event => {
  reachFloor(event.target.dataset.reach);
};



export const init = () => {
  setVars();

  if (!SP.sportspage) return;

  if (SP.navBar && SP.navBarItems ) {
    fixNavBar();
    document.on('scroll', cube.debounce(fixNavBar, 10));

    highlightNavBarItems();
    document.on('scroll', cube.debounce(highlightNavBarItems, 25));

    document.on('keydown', keyboardNavigation);
    SP.navBar.delegate('click', '.sportspage__nav-item', navBarNavigation);
    SP.internalNavItems.on('click', internalNavigation);
  }

  if (cube.$id('sportspage-subcategoriesfloor'))
    import('./floors/subcategoriesfloor').then(({ init: initFloorSubCategories }) => initFloorSubCategories());

  if (cube.$id('sportspage__flooradvice'))
    import('./floors/flooradvice').then(({ init: initFloorAdvice }) => initFloorAdvice());

  if (cube.$id('sportspage__opecofloor'))
    import('./floors/opecofloor').then(({ init: initFloorOpeco }) => initFloorOpeco());
};



// WEBPACK FOOTER //
// ./src/catalog/sportspage/sportspage.js